var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '../elements/index';
export var RoundArrowButtonDirection;
(function (RoundArrowButtonDirection) {
    RoundArrowButtonDirection["UP"] = "up";
    RoundArrowButtonDirection["DOWN"] = "down";
    RoundArrowButtonDirection["LEFT"] = "left";
    RoundArrowButtonDirection["RIGHT"] = "right";
})(RoundArrowButtonDirection || (RoundArrowButtonDirection = {}));
const RoundArrowButton = props => {
    const { className, direction, transparent, outlined } = props, rest = __rest(props, ["className", "direction", "transparent", "outlined"]);
    const classNames = classnames('RoundArrowButton', { 'RoundArrowButton--outlined': outlined }, { 'RoundArrowButton--transparent': transparent }, { [`RoundArrowButton--${direction}`]: direction }, className);
    return React.createElement(Button, Object.assign({ className: classNames }, rest));
};
export default RoundArrowButton;
